module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/ten.1851604.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/ten.jpg
// module id = yoyd
// module chunks = 0